import * as Swetrix from 'swetrix'

Swetrix.init('2OFKnoIp7lvQ', {
  apiURL: 'https://swetrix-api.vuetifyjs.com/log',
})
Swetrix.trackViews()
Swetrix.trackErrors()
